module.exports = __webpack_public_path__ + "img/av046.9c2448de.png";